<script>
export default {
  name: "client-overview",
  props: {
    client: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      item: {
        loading: true,
        client: {}
      }
    }
  },
  mounted() {
    this.getItem()
  },
  methods: {
    getItem() {
      this.$http.get(this.routeUri('hyperion.client.show', {
        client_hash: this.client
      })  + '?q=').then(res => this.item.client = res.data)
        .catch(err => this.handleXhrError(err))
        .finally(() => this.item.loading = false)
    }
  }
}
</script>

<template>
  <div>
    <a-row :gutter="16" type="flex" align="middle">
      <a-col :span="6">
        <a-card>
          <a-skeleton :loading="item.loading" active>
            <a-statistic title="Products Count" :value="item.client.products_count" groupSeparator="."
                         :valueStyle="{color: '#3f8600'}">
              <template v-slot:prefix>
                <a-icon type="qrcode"/>
              </template>
            </a-statistic>
          </a-skeleton>
        </a-card>
      </a-col>

      <a-col :span="6">
        <a-card>
          <a-skeleton :loading="item.loading" active>
            <a-statistic title="Balance Requests Total" :value="item.client.balance_requests_count" groupSeparator="."
                         prefix="IDR" :valueStyle="{color: '#3f8600'}">
            </a-statistic>
          </a-skeleton>
        </a-card>
      </a-col>

      <a-col :span="6">
        <a-card>
          <a-skeleton :loading="item.loading" active>
            <a-statistic title="Transactions Count" :value="item.client.transactions_count" groupSeparator="."
                         :valueStyle="{color: '#3f8600'}">
              <template v-slot:prefix>
                <a-icon type="barcode"/>
              </template>
            </a-statistic>
          </a-skeleton>
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>

<style scoped>

</style>
